import {Component, inject, OnInit} from '@angular/core';
import {PaypalButton} from '../paypal-button/paypal-button';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import countriesRaw from '../../assets/data/countries.json' assert {type: 'json'};
import euVatRaw from '../../assets/data/eu_vat.json' assert {type: 'json'};
import {Router} from '@angular/router';
import {CartService} from '../services/cart';
import {environment} from '../../environments/environment';
import {PaypalGrowthButton} from "../paypal-growth-button/paypal-growth-button";
import {AuthService} from '../services/auth';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-checkout',
  imports: [
    PaypalButton,
    PaypalGrowthButton,
    ReactiveFormsModule,
    TranslatePipe
  ],
  templateUrl: './checkout.html',
  styleUrl: './checkout.scss'
})
export class Checkout implements OnInit {
  email = '';
  private apiUrl = environment.apiBaseUrl;
  checkoutForm: FormGroup;
  countryList: { code: string; name: string }[] = [];
  http = inject(HttpClient)
  euVat = euVatRaw;
  vatRate: number = 0.0;
  hasAccount = false
  router = inject(Router)
  cartService = inject(CartService)
  authService = inject(AuthService)
  constructor(private fb: FormBuilder) {
    this.checkMail();
    this.checkoutForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.email, Validators.required]],
      // password: ['', [Validators.required, Validators.minLength(6)]],
      address: ['', Validators.required],
      address2: [''],
      city: ['', Validators.required],
      country: ['', Validators.required],
      zip: ['', Validators.required],
    });
    // this.updatePasswordControl();
  }

  // toggleAccountStatus(hasAccount: boolean) {
  //   this.hasAccount = hasAccount;
  //   this.updatePasswordControl();
  // }
  //
  // private updatePasswordControl() {
  //   if (!this.hasAccount) {
  //     // this.checkoutForm.addControl(
  //     //   'password',
  //     //   this.fb.control('', [Validators.required, Validators.minLength(6)])
  //     // );
  //     this.checkoutForm.get('password')?.enable();
  //   } else {
  //     this.checkoutForm.get('password')?.disable();
  //     this.checkoutForm.removeControl('password');
  //   }
  // }

  ngOnInit(): void {
    this.countryList = Object.entries(countriesRaw).map(([code, name]) => ({ code, name }));
    this.countryList.sort((a, b) => a.name.localeCompare(b.name));
    this.checkoutForm.get('country')?.valueChanges.subscribe(code => {
      this.updateVatRate(code);
      this.changeItemsBasedOnVatRate();
    });
    this.checkMail();
  }

  updateVatRate(countryCode: string) {
    // Find the VAT rate from euVatRaw by code
    const countryVat = this.euVat.find((c: any) => c.code === countryCode);
    if (countryVat) {
      this.vatRate = countryVat.vat_rate;
    } else {
      this.vatRate = 0.0;
    }
  }
  onSubmit(): void {
    if (this.checkoutForm.valid) {
      const jsonData = this.checkoutForm.value;
      console.log(jsonData);
    } else {
      this.checkoutForm.markAllAsTouched();
    }
  }

// You can also fetch this from the backend
  productDetails: Record<string, { name: string, price: number, description: string }> = {
    'growth_plan': { name: '🌱 Growth Member', price: 14.99, description: 'Monthly growth subscription' },
    'ultimate_plan': { name: '🚀 Ultimate Member', price: 29.99, description: 'All-inclusive subscription' },
    'credits_100': { name: '⭐ 100 Credits', price: 1.99, description: 'One-time 100 credits pack' },
    'credits_250': { name: '⭐ 250 Credits', price: 2.99, description: 'One-time 250 credits pack' },
    'credits_750': { name: '⭐ 750 Credits', price: 6.99, description: 'One-time 750 credits pack' }
  };

  changeItemsBasedOnVatRate() : void {
    this.productDetails['growth_plan'].price = 14.99  / (1 + 0.01 * this.vatRate);
    this.productDetails['ultimate_plan'].price = 29.99 / (1 + 0.01 * this.vatRate);
    this.productDetails['credits_100'].price = 1.99  / (1 + 0.01 * this.vatRate);
    this.productDetails['credits_250'].price = 2.99  / (1 + 0.01 * this.vatRate);
    this.productDetails['credits_750'].price = 6.99  / (1 + 0.01 * this.vatRate);
  }

  getSubtotal(): number {
    return this.cartService.getItems().reduce((sum, item) => {
      const price = this.productDetails[item.id]?.price ?? 0;
      return sum + price * item.quantity;
    }, 0);
  }

  getTotal(): number {
    const subtotal = this.getSubtotal() * (1 + 0.01 * this.vatRate);
    const vat = subtotal / (1 + 0.01 * this.vatRate);
    // total is 1 + vatRate

    return subtotal ;
  }

  checkMail() {
    const token = this.authService.getToken();

    fetch( `${this.apiUrl}/get-email`, {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    })
      .then(response => response.json())
      .then(data => {
          this.email = data.email;

          console.log(this.email)
          if (this.email !== undefined) {
            // this.toggleAccountStatus(true)
            this.checkoutForm.get('email')?.setValue(this.email);
            this.checkoutForm.get('email')?.disable();
          }
          // else {
            // this.toggleAccountStatus(false)
          // }
        }
      )
      .catch(err => console.error("Error:", err))
      .finally(
      );
  }
}
